import './Logo.css';

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import STATUS from '../Constants';

import logo from './logo.svg';

const Logo = (props) => {
  return (
    <CSSTransition
      in={props.status === STATUS.LOGO}
      timeout={1000}
      appear={true}
      exit={false}
      unmountOnExit
      classNames="fade-up">

      <div className="Logo flex flex--direction-c flex--align-c flex--justify-c">
        <img className="logo" src={logo} alt="Double Up" />

        <div className="contentContainer content">
          <p>Test your knowledge about responsible gambling habits with this fun memory matching card game</p>
        </div>

        <div className="Logo__ctas">
          <div className="contentContainer">
            <button className="button" onClick={props.startGame}>Play game</button>
          </div>
          <div className="contentContainer">
            <button className="button" onClick={props.playIntro}>Watch tutorial</button>
          </div>
        </div>
      </div>

    </CSSTransition>
  )
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/du/Game/Logo/Logo.js